"use client";

import React from "react";
import { MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cities = ["Body Rituals", "Foot Therapy", "Combo Packages", "Deep Tissue", "Swedish Flow", "Hot Stone", "Aromatherapy", "Reflexology", "Scalp Massage", "Hand Care", "Herbal Poultice", "Sound Healing", "Meditation"];
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="256928" id="find-your-sanctuary" className="relative min-h-[85vh] flex items-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/sanctuary_treatment_room.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/sanctuary_treatment_room.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/sanctuary_treatment_room.png-wvc-sizes" alt="Candle-lit treatment room sanctuary" className="w-full h-full object-cover object-center transition-transform duration-[10000ms] ease-linear scale-110" style={{
        transform: isVisible ? 'scale(1)' : 'scale(1.1)'
      }} loading="eager" decoding="async" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/20"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 py-20 md:py-32">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}

          {}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-default font-bold text-primary mb-6 leading-[1.1]"></h1>

          {}
          <h2 className="font-default mb-6 !font-semibold !text-8xl !text-[rgba(0,0,0,1)] rounded-xl !bg-transparent">Real Relief, Right Here in Portland</h2>

          {}
          <p className="text-foreground/80 mb-10 max-w-2xl leading-relaxed !font-sans !text-xl">A relaxed, professional massage and body treatment spot in the heart of Portland. Come in, let our staff get to work, and leave feeling better than when you walked in.</p>

          {}
          <div className="flex flex-wrap items-center gap-4 mb-12">
            <Button size="lg" className="text-base px-8 h-14 rounded-lg shadow-md shadow-primary/10 bg-primary text-primary-foreground hover:opacity-90 transition-opacity" asChild>
              <Link to="/ServicesPage">
                Explore Treatments
              </Link>
            </Button>
            <Button variant="outline" size="lg" className="text-base px-8 h-14 rounded-lg bg-transparent border-none hover:bg-transparent text-primary font-sans font-medium underline underline-offset-4" asChild>
              
            </Button>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}